import { z } from 'zod'
import { decimalSchema, timestampSchema, uuidSchema } from './common.ts'
import { productionPlanMonthSchema } from './production-plan.ts'

export const productionScrapQuerySchema = z.strictObject({
  month: productionPlanMonthSchema,
})
export type ProductionScrapQuery = z.infer<typeof productionScrapQuerySchema>

export const productionScrapRecordSchema = z.object({
  id: uuidSchema,
  stageId: uuidSchema,
  createdAt: timestampSchema,
  orderId: uuidSchema,
  orderNumber: z.string(),
  orderKind: z.enum(['customer', 'internal']),
  itemName: z.string(),
  operationName: z.string(),
  workCenterName: z.string().nullable(),
  equipmentName: z.string().nullable(),
  operatorName: z.string(),
  scrapQuantity: decimalSchema,
  unitSymbol: z.string().nullable(),
  // Null only for scrap recorded before a reason was required.
  reason: z.string().nullable(),
  note: z.string().nullable(),
})
export type ProductionScrapRecord = z.infer<typeof productionScrapRecordSchema>

// Quantities in different units cannot be added, so every total is per unit.
export const productionScrapTotalSchema = z.object({
  unitSymbol: z.string().nullable(),
  quantity: decimalSchema,
  records: z.number().int().nonnegative(),
})
export type ProductionScrapTotal = z.infer<typeof productionScrapTotalSchema>

export const productionScrapOrderTotalSchema = productionScrapTotalSchema.extend({
  orderId: uuidSchema,
  orderNumber: z.string(),
})
export type ProductionScrapOrderTotal = z.infer<typeof productionScrapOrderTotalSchema>

export const productionScrapRegisterSchema = z.object({
  month: productionPlanMonthSchema,
  records: z.array(productionScrapRecordSchema),
  totals: z.array(productionScrapTotalSchema),
  orderTotals: z.array(productionScrapOrderTotalSchema),
})
export type ProductionScrapRegister = z.infer<typeof productionScrapRegisterSchema>
